import CB_VERSION_TYPE from '@/app/modules/contracts/enums/CbVersionType';
import APPLICATIONS from '@/app/modules/contracts/enums/ItpRegex';
import REMOTE_COLLECTION_RECONCILIATION_CODE from '../enums/RemoteCollectionReconciliationCode';
import { nsContract, nsRemoteCollection, nsTerminal } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'keys.created_at',
        namespace: nsRemoteCollection,
        filter: 'date',
        enableSorting: false
    },
    RECONCILIATION_NUMBER: {
        key: 'reconciliationNumber',
        type: 'textarea',
        entity: 'keys.reconciliation_number',
        namespace: nsRemoteCollection,
        filter: 'input',
        placeholder: 'filter.placeholder.reconciliation_number',
        enableSorting: false,
        isNested: true
    },
    MESSAGES_NUMBER: {
        key: 'messagesNumber',
        type: 'textarea',
        entity: 'keys.messages_number',
        namespace: nsRemoteCollection,
        filter: 'input',
        placeholder: 'filter.placeholder.messages_number',
        enableSorting: false
    },
    ERT: {
        key: 'ert',
        type: 'textarea',
        entity: 'remoteCollection_ert'
    },
    LOCAL_TRANSACTION_DATE_TIME: {
        key: 'localTransactionDateTime',
        type: 'date',
        entity: 'keys.transaction_date',
        namespace: nsRemoteCollection,
        filter: 'date',
        isLocalDateAndTime: true,
        enableSorting: false
    },
    RECONCILIATION_CODE: {
        key: 'reconciliationCode',
        type: 'textarea',
        prefix: 'remoteCollection_reconciliation_code_',
        entity: 'keys.reconciliation_code',
        namespace: nsRemoteCollection,
        filter: 'select',
        enum: REMOTE_COLLECTION_RECONCILIATION_CODE,
        enableSorting: false
    },
    CREDITS_NUMBER: {
        key: 'creditsNumber',
        type: 'textarea',
        entity: 'remoteCollection_credits_number'
    },
    DEBITS_NUMBER: {
        key: 'debitsNumber',
        type: 'textarea',
        entity: 'remoteCollection_debits_number'
    },
    DEBITS_REVERSAL_NUMBER: {
        key: 'debitsReversalNumber',
        type: 'textarea',
        entity: 'remoteCollection_debits_reversal_number'
    },
    NON_COMPLETED_NUMBER: {
        key: 'nonCompletedNumber',
        type: 'textarea',
        entity: 'remoteCollection_non_completed_number'
    },
    CREDITS_AMOUNT: {
        key: 'creditsAmount',
        type: 'textarea',
        entity: 'remoteCollection_credits_amount'
    },
    DEBITS_AMOUNT: {
        key: 'debitsAmount',
        type: 'textarea',
        entity: 'remoteCollection_debits_amount'
    },
    DEBITS_REVERSAL_AMOUNT: {
        key: 'debitsReversalAmount',
        type: 'textarea',
        entity: 'remoteCollection_debits_reversal_amount'
    },
    TOTAL_AMOUNT: {
        key: 'totalAmount',
        type: 'textarea',
        entity: 'keys.total_amount',
        namespace: nsRemoteCollection,
        filter: 'number',
        placeholder: 'filter.placeholder.total_amount',
        enableSorting: false
    },
    TOTAL_REVENUE: {
        key: 'totalAmountsSum',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.total_revenue',
        namespace: nsRemoteCollection
    },
    CONTRACT: {
        key: 'contract',
        type: 'textarea',
        entity: 'keys.contract_number',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.contract',
        enableSorting: false
    },
    RANK: {
        key: 'rank',
        type: 'textarea',
        entity: 'keys.rank',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.rank',
        enableSorting: false
    },
    ITP: {
        key: 'itp',
        type: 'textarea',
        entity: 'remoteCollection_itp'
    },
    CURRENCY: {
        key: 'currency',
        type: 'textarea',
        entity: 'remoteCollection_currency'
    },
    MCC: {
        key: 'mcc',
        type: 'textarea',
        entity: 'remoteCollection_mcc'
    },
    BANK_CODE: {
        key: 'bankCode',
        type: 'textarea',
        entity: 'keys.bank_code',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.bank_code',
        enableSorting: false
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: 'textarea',
        entity: 'keys.registration_number',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.registration_number',
        enableSorting: false
    },
    APPLICATION: {
        key: 'application',
        type: 'textarea',
        entity: 'keys.application',
        namespace: nsContract,
        filter: 'select',
        enum: APPLICATIONS,
        enableSorting: false,
        sortOptions: true
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: 'textarea',
        entity: 'keys.legal_name',
        namespace: nsRemoteCollection,
        filter: 'input',
        placeholder: 'filter.placeholder.legal_name',
        enableSorting: false
    },
    TRANSACTION_COUNT: {
        key: 'transactionCount',
        type: 'textarea',
        entity: 'keys.transaction_count',
        namespace: nsRemoteCollection,
        filter: 'number',
        placeholder: 'filter.placeholder.transaction_count',
        enableSorting: false
    },
    CB_VERSION: {
        key: 'cbVersion',
        type: 'text',
        prefix: 'cbVersionType_',
        entity: 'keys.cb_version',
        namespace: nsContract,
        filter: 'select',
        enum: CB_VERSION_TYPE,
        enableSorting: false
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            key: 'serialNumber',
            type: 'text',
            entity: 'keys.serial_number',
            namespace: nsTerminal,
            filter: 'input',
            placeholder: 'filter.placeholder.serial_number',
            enableSorting: false,
            isNested: true
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: 'text',
            entity: 'keys.manufacturer',
            namespace: nsTerminal,
            filter: 'input',
            placeholder: 'filter.placeholder.manufacturer',
            enableSorting: false,
            isNested: true
        },
        LABEL: {
            parentKeys: ['posTerminal'],
            key: 'label',
            type: 'text',
            entity: 'keys.label',
            namespace: nsTerminal,
            filter: 'input',
            placeholder: 'filter.placeholder.label',
            enableSorting: false,
            isNested: true
        },
        CUSTOM_LABEL: {
            parentKeys: ['posTerminal'],
            key: 'customLabel',
            type: 'text',
            entity: 'keys.custom_label',
            namespace: nsTerminal,
            filter: 'input',
            placeholder: 'filter.placeholder.custom_label',
            enableSorting: false,
            isNested: true
        }
    },
    SUBSCRIPTION: {
        key: 'subscription'
    },
    POS_REMITTANCE_NUMBER: {
        key: 'posRemittanceNumber',
        type: 'text',
        entity: 'keys.remittance_number',
        namespace: nsRemoteCollection,
        filter: 'input',
        placeholder: 'filter.placeholder.remittance_number',
        enableSorting: false
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    }
};